import { Model, View } from "@lernetz/ts-lib";
import { gateway } from "../../services/gateway";
import { router } from "../../services/router";
import template from "./tools.view.html";

import { Tag, toggleFilter } from "../../components/filter/filter.helpers";
import {tagService} from "../../services/tag.service";
import {languageService} from "../../services/lang";

export class ToolsPageView extends View<ToolsPageController> {
    constructor() {
        super({ template });
    }
}

export class ToolsPageController extends Model {
    canLoadMore: boolean;
    tools: any;
    topics: string | {};
    tags: string[];
    filters: string | {};
    activeFilters: any;
    currentLang: string;
    constructor(searchString: string) {
        super();
    }
    init() {
        this.currentLang = languageService.currentLang;
        gateway.loadTopics().then((topics) => (this.topics = topics));
        gateway.loadFilters().then((filterCategories) => {
            this.activeFilters = tagService.getActiveTagsFromParam(
                filterCategories,
                this.parseParams()
            );
            this.loadTools(this.activeFilters);
            this.filters = this.prepareFilters(
                filterCategories,
                this.activeFilters
            );
        });
    }

    private loadTools(activeFilters) {
        const searchParams = this.apiSearchParams(activeFilters);
        gateway.toolGateway
            .loadFilteredTools(searchParams)
            .then((tools) => (this.tools = tools));
    }

    private apiSearchParams(activeFilters) {
        if (!this.activeFilters.length) {
            this.canLoadMore = true;
            return "?limit=9";
        } else {
            return this.createParams();
        }
    }

    loadMore() {
        this.canLoadMore = false;
        gateway.toolGateway
            .loadFilteredTools(this.createParams())
            .then((tools) => (this.tools = tools));
    }

    private parseParams() {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.has("tags")
            ? searchParams.get("tags").split(",")
            : null;
    }

    setActiveTags(tags: Tag[]) {
        this.activeFilters = tags;
        this.filters = this.prepareFilters(this.filters, this.activeFilters);
        this.loadTools(this.activeFilters);
        this.updateUri();
    }

    updateUri() {
        const params = this.createParams();
        const uri = params
            ? `/${this.currentLang}/tools/${params}` //`/${this.currentLang}/filter/tools/${params}`
            : `/${this.currentLang}/tools`;
        // router.writeURL(uri);
        // route writes url wrong with query params

        let currentPath = window.location.href;
        let url = new URL( currentPath );
        let newPath = `${url.origin}${uri}`;

        // only push if current path is different
        if( newPath != currentPath ) history.pushState( {}, '', newPath );
    }

    createParams() {
        const tagSlugs = this.activeFilters.map((f) => f.slug);
        return tagSlugs.length ? `?tags=${encodeURI(tagSlugs.join(","))}` : "";
    }

    private prepareFilters(filterCategories, selectedTags) {
        const activeSlugs = selectedTags.map((tag) => tag.slug);

        const filters = filterCategories.map((filter) => {
            return {
                ...filter,
                tags: filter.tags.map((tag) => {
                    return {
                        active: activeSlugs.includes(tag.slug),
                        ...tag,
                    };
                }),
            };
        });
        return filters;
    }
}


class FilterDropDown extends Model {
    constructor(dto) {
        super(dto);
    }
}
